/**
 * RBAC role ladder for Detect, aligned with the Desk family ladder plus a
 * read-only `viewer` rung (technical-architecture.md §3):
 *
 *   viewer(0) < agent(1) < supervisor(2) < admin(3) < account_admin(4)
 *
 * Global roles sit above tenant roles: user < globaladmin < superadmin.
 * A tenant grant may additionally be scoped to specific client groups
 * within the tenant (clientIds on the membership).
 */
export const TENANT_ROLES = [
    'viewer',
    'agent',
    'supervisor',
    'admin',
    'account_admin',
];
export const TENANT_ROLE_HIERARCHY = {
    viewer: 0,
    agent: 1,
    supervisor: 2,
    admin: 3,
    account_admin: 4,
};
export const GLOBAL_ROLES = ['user', 'globaladmin', 'superadmin'];
//# sourceMappingURL=roles.js.map